import { actions } from 'actions';

/**
 * ヘッダーリセット 
 */
export const clearHeader = () => (dispatch) => {
  dispatch({
    type: actions.CLEAR_HEADER,
  });
};

/**
 * ヘッダーセットアクション
 * 
 * @param type button|unit|page
 */
export const setHeader = (email = '') => (dispatch) => {
  dispatch({
    type: actions.SET_HEADER,
    isAccount: true,
    isProgram: true,
    mail: email
  });
};